import { SendOpinionVars } from '~/api/opinion'

import { Validations } from '~/common/form/validation'
import { FormWidgetError } from '~/common/form/formError'
import { FileTypeBase } from '~/common/form/type'

export interface OpinionType extends FileTypeBase {
  opinion: string
}

export const initialData: OpinionType = {
  opinion: '',
}

export const opinionValidation: Validations = {
  opinion: [FormWidgetError.IS_EMPTY, FormWidgetError.OVER_TEXT_STRING_MAX],
}

export const convertToOpinionRequestValues = (type: OpinionType, pathName: string, userAgent: string): SendOpinionVars => {
  return {
    ...type,
    path: pathName,
    user_agent: userAgent
  }
}